import { FC } from 'react'

import styled from 'styled-components'

import IconSuccessfully from 'src/Assets/Svg/successfully.svg?react'
import { variables } from 'src/Styled/variables'
import dayJs from 'src/Helpers/dayjs'

const Container = styled.div`
  display: flex;
  width: 320px;
  padding: 40px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  @media (min-width: 567px) {
    padding: 40px 16px;
    width: 560px;
  }
`
const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Description = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-size: ${variables.fontSize14};
  font-weight: 400;
  line-height: 150%;
`

interface UnsubscribedProps {
  date?: string
}

export const Unsubscribed: FC<UnsubscribedProps> = ({ date }) => {
  const cancelDate = date ? dayJs(date).format('DD MMM, YYYY') : null
  return (
    <Container>
      <IconSuccessfully />
      <TitleContainer>
        <Title>You have successfully unsubscribed</Title>
        {cancelDate && (
          <Description>{`Your subscription will remain active until ${cancelDate}`}</Description>
        )}
      </TitleContainer>
    </Container>
  )
}
